import moment from "moment";
import * as XLSX from "xlsx";

export default function() {
  const configs = window.CONFIG;
  (this.rootURL = configs.BASEURL),
    (this.baseURL = `${this.rootURL}/api`),
    (this.photorootURL = `${this.rootURL}/Photos`),
    (this.baseCurrencyCode = "HKD"),
    // get localized string by field type and field name
    (this.getLocalizedString = function(fieldType, fieldName) {
      var data = JSON.parse(this.getLocalizedData()); //GET THE ARRAY FROM LOCAL STORAGE
      if (data != null) {
        data = data.Data;
        if (data) {
          var returnedString = data.filter(
            obj => obj.FieldType == fieldType && obj.FieldName == fieldName
          );
          if (returnedString.length > 0) {
            return returnedString[0].MsgString;
          } else {
            return fieldType + "." + fieldName;
          }
        }
      }
    }),
    //不能調用getDN這個接口的公司（2025-09-17 Jason提出）
    (this.NoNeedDNCompCode = []), //必須全部大寫
    (this.formatString = function(format, args) {
      var i;
      if (args instanceof Array) {
        for (i = 0; i < args.length; i++) {
          format = format.replace(new RegExp("\\{" + i + "\\}", "gm"), args[i]);
        }
        return format;
      }
      for (i = 0; i < arguments.length - 1; i++) {
        format = format.replace(
          new RegExp("\\{" + i + "\\}", "gm"),
          arguments[i + 1]
        );
      }
      return format;
    }),
    // auth token in local storage
    (this.getAuthToken = function() {
      return localStorage.getItem("AuthToken");
    }),
    (this.setAuthToken = function(authToken) {
      return localStorage.setItem("AuthToken", authToken);
    }),
    (this.removeAuthToken = function() {
      return localStorage.removeItem("AuthToken");
    }),
    // stay logged in value in local storage
    (this.getStayLoggedIn = function() {
      return localStorage.getItem("StayLoggedIn");
    }),
    (this.setStayLoggedIn = function(stayLoggedIn) {
      return localStorage.setItem("StayLoggedIn", stayLoggedIn);
    }),
    (this.removeStayLoggedIn = function() {
      return localStorage.removeItem("StayLoggedIn");
    }),
    // user name in local storage
    (this.getUserName = function() {
      return localStorage.getItem("UserName");
    }),
    (this.setUserName = function(username) {
      return localStorage.setItem("UserName", username);
    }),
    (this.removeUserName = function() {
      return localStorage.removeItem("UserName");
    }),
    (this.setIsClient = function(value) {
      return localStorage.setItem("IsClient", value);
    }),
    (this.getIsClient = function() {
      return localStorage.getItem("IsClient") == "true";
    }),
    (this.removeIsClient = function() {
      return localStorage.removeItem("IsClient");
    }),
    (this.setClientCompanyName = function(name) {
      return localStorage.setItem("ClientCompanyName", name);
    }),
    (this.getClientCompanyName = function() {
      return localStorage.getItem("ClientCompanyName");
    }),
    (this.removeClientCompanyName = function() {
      return localStorage.removeItem("ClientCompanyName");
    }),
    (this.setClientEntNum = function(value) {
      return localStorage.setItem("ClientEntNum", value);
    }),
    (this.getClientEntNum = function() {
      return localStorage.getItem("ClientEntNum");
    }),
    (this.removeClientEntNum = function() {
      return localStorage.removeItem("ClientEntNum");
    }),
    (this.setClientDeliveryAddresses = function(values) {
      return localStorage.setItem(
        "ClientDeliveryAddresses",
        JSON.stringify(values)
      );
    }),
    (this.getClientDeliveryAddresses = function() {
      return JSON.parse(localStorage.getItem("ClientDeliveryAddresses"));
    }),
    (this.removeClientDeliveryAddresses = function() {
      return localStorage.removeItem("ClientDeliveryAddresses");
    }),
    (this.getClientItemsInCart = function() {
      return JSON.parse(localStorage.getItem("ClientItemsInCart"));
    }),
    (this.setClientItemsInCart = function(obj) {
      return localStorage.setItem("ClientItemsInCart", JSON.stringify(obj));
    }),
    (this.removeClientItemsInCart = function() {
      return localStorage.removeItem("ClientItemsInCart");
    })(
      // user id in local storage
      (this.getUserId = function() {
        return localStorage.getItem("UserId");
      })
    ),
    (this.setUserId = function(userId) {
      return localStorage.setItem("UserId", userId);
    }),
    (this.removeUserId = function() {
      return localStorage.removeItem("UserId");
    }),
    // company name in local storage
    (this.getCompanyName = function() {
      return localStorage.getItem("CompanyName");
    }),
    (this.setCompanyName = function(companyname) {
      return localStorage.setItem("CompanyName", companyname);
    }),
    (this.removeCompanyName = function() {
      return localStorage.removeItem("CompanyName");
    }),
    // company name in local storage
    (this.getCompanyLongName = function() {
      return localStorage.getItem("CompanyLongName");
    }),
    (this.setCompanyLongName = function(companyname) {
      return localStorage.setItem("CompanyLongName", companyname);
    }),
    (this.removeCompanyLongName = function() {
      return localStorage.removeItem("CompanyLongName");
    }),
    // user language in local storage
    (this.getLanguage = function() {
      return localStorage.getItem("Language");
    }),
    (this.setLanguage = function(language) {
      return localStorage.setItem("Language", language);
    }),
    (this.removeLanguage = function() {
      return localStorage.removeItem("Language");
    }),
    // Brand Label in local storage
    (this.getlblBrand = function() {
      return localStorage.getItem("LblBrand");
    }),
    (this.setlblBrand = function(lblbrand) {
      return localStorage.setItem("LblBrand", lblbrand);
    }),
    (this.removelblBrand = function() {
      return localStorage.removeItem("LblBrand");
    }),
    // Cate1 Label in local storage
    (this.getlblCate1 = function() {
      return localStorage.getItem("LblCate1");
    }),
    (this.setlblCate1 = function(lblcate1) {
      return localStorage.setItem("LblCate1", lblcate1);
    }),
    (this.removelblCate1 = function() {
      return localStorage.removeItem("LblCate1");
    }),
    // Cate2 Label in local storage
    (this.getlblCate2 = function() {
      return localStorage.getItem("LblCate2");
    }),
    (this.setlblCate2 = function(lblcate2) {
      return localStorage.setItem("LblCate2", lblcate2);
    }),
    (this.removelblCate2 = function() {
      return localStorage.removeItem("LblCate2");
    }),
    // Char Label in local storage
    (this.getlblChar = function() {
      return localStorage.getItem("LblChar");
    }),
    (this.setlblChar = function(lblchar) {
      return localStorage.setItem("LblChar", lblchar);
    }),
    (this.removelblChar = function() {
      return localStorage.removeItem("LblChar");
    }),
    // Series Label in local storage
    (this.getlblSeries = function() {
      return localStorage.getItem("LblSeries");
    }),
    (this.setlblSeries = function(lblseries) {
      return localStorage.setItem("LblSeries", lblseries);
    }),
    (this.removelblSeries = function() {
      return localStorage.removeItem("LblSeries");
    }),
    // user allow view Cost in local storage
    (this.getAllowViewCost = function() {
      return localStorage.getItem("AllowViewCost");
    }),
    (this.setAllowViewCost = function(allowViewCost) {
      return localStorage.setItem("AllowViewCost", allowViewCost);
    }),
    (this.removeAllowViewCost = function() {
      return localStorage.removeItem("AllowViewCost");
    }),
    // loading panel
    (this.startLoading = function() {
      $("#customLoader").css("display", "block");
    }),
    (this.stopLoading = function() {
      $("#customLoader").css("display", "none");
    }),
    // localized data in local storage
    (this.getLocalizedData = function() {
      return localStorage.getItem("LocalizedData");
    }),
    (this.setLocalizedData = function(localizedData) {
      return localStorage.setItem("LocalizedData", localizedData);
    }),
    (this.removeLocalizedData = function() {
      return localStorage.removeItem("LocalizedData");
    }),
    //Menu data in local storage
    (this.getMenuData = function() {
      return localStorage.getItem("MenuData");
    }),
    (this.setMenuData = function(setMenuData) {
      return localStorage.setItem("MenuData", setMenuData);
    }),
    (this.removeMenuData = function() {
      return localStorage.removeItem("MenuData");
    }),
    //Menu data in local storage
    (this.getUserRightsMenuData = function() {
      return localStorage.getItem("UserRights");
    }),
    (this.setUserRightsMenuData = function(userrights) {
      return localStorage.setItem("UserRights", userrights);
    }),
    (this.removeUserRightsMenuData = function() {
      return localStorage.removeItem("UserRights");
    }),
    // set search critetia
    (this.setSearchCriteria = function(
      selectedSearchCriteria,
      columnsList,
      searchString
    ) {
      var reg = /^[\u4E00-\u9FA5]+$/;
      if (searchString == null || searchString === "") {
        return "";
      } else if (selectedSearchCriteria != "All") {
        if (reg.test(searchString)) {
          //如果是中文
          return selectedSearchCriteria + " like N'%" + searchString + "%'";
        } else {
          return selectedSearchCriteria + " like '%" + searchString + "%'";
        }
      } else {
        var searchCriteria = "";
        const excludeColumns = [
          "DateAdd",
          "DateModify",
          "AddBy",
          "ModifyBy",
          "RecDel"
        ];
        const filterColumns = columnsList.filter(
          col => col.searchKey && !excludeColumns.includes(col.searchKey)
        );
        console.log(filterColumns, "----filterColumns");
        for (var i = 0; i < filterColumns.length; i++) {
          if (i != 0) {
            searchCriteria += " OR ";
          }
          if (reg.test(searchString)) {
            //如果是中文
            searchCriteria +=
              filterColumns[i].searchKey + " like N'%" + searchString + "%'";
          } else {
            searchCriteria +=
              filterColumns[i].searchKey + " like '%" + searchString + "%'";
          }
        }
        return searchCriteria;
      }
    }),
    (this.setSearchCriteriaPopup = function(
      selectedSearchCriteria,
      columnsList,
      searchString
    ) {
      if (!searchString || searchString == "") return "";
      if (selectedSearchCriteria != "All") {
        return selectedSearchCriteria + " like '%" + searchString + "%'";
      } else {
        var searchCriteria = "";
        for (var i = 0; i < columnsList.length; i++) {
          if (columnsList[i].value == "All") continue;
          if (searchCriteria != "") {
            searchCriteria += " or ";
          }
          searchCriteria +=
            columnsList[i].value + " like '%" + searchString + "%'";
        }
        return searchCriteria;
      }
    }),
    // set sorting parameter
    (this.applySorting = function(fieldName, sortOrder, columnsList) {
      columnsList.forEach(function(element) {
        $("#" + element.searchKey + ">span>img").attr(
          "src",
          "image/common_ordering.png"
        );
      }, this);
      if (sortOrder.split(",").length > 1) {
        var sorder = sortOrder.split(",")[1];
        var sorderName = sortOrder.split(",")[0];
        if (sorderName != fieldName) {
          sortOrder = fieldName + ",asc";
          $("#" + fieldName + ">span>img").attr("src", "image/DropUp.png");
        } else if (sorder == "asc" && sorderName == fieldName) {
          sortOrder = fieldName + ",dsc";
          $("#" + fieldName + ">span>img").attr("src", "image/DropDown.png");
        } else if (sorder == "dsc" && sorderName == fieldName) {
          sortOrder = fieldName + ",asc";
          $("#" + fieldName + ">span>img").attr("src", "image/DropUp.png");
        }
      } else {
        sortOrder = fieldName + ",asc";
        $("#" + fieldName + ">span>img").attr("src", "image/DropUp.png");
      }
      return sortOrder;
    }),
    //formate date
    (this.formatDate = function(date) {
      if (date != null && date != undefined && date != "") {
        var dt = new Date(parseInt(date.substring(6, date.length - 2)));
        var formatedDate =
          dt.getFullYear() +
          "-" +
          this.pad2(dt.getMonth() + 1) +
          "-" +
          this.pad2(dt.getDate());
        return formatedDate;
      }
    }),
    //formate date time
    (this.formatDateTime = function(date) {
      if (date != null && date != undefined && date != "") {
        var dt = new Date(parseInt(date.substring(6, date.length - 2)));
        var formatedDate =
          dt.getFullYear() +
          "-" +
          this.pad2(dt.getMonth() + 1) +
          "-" +
          this.pad2(dt.getDate()) +
          " " +
          this.pad2(dt.getHours()) +
          ":" +
          this.pad2(dt.getMinutes()) +
          ":" +
          this.pad2(dt.getSeconds()) +
          "." +
          this.pad3(dt.getMilliseconds());
        return formatedDate;
      }
    }),
    //formate date time without seconds
    (this.formatDateTimewithoutsecond = function(date) {
      if (date != null && date != undefined && date != "") {
        var dt = new Date(parseInt(date.substring(6, date.length - 2)));
        var formatDateTime =
          dt.getFullYear() +
          "-" +
          this.pad2(dt.getMonth() + 1) +
          "-" +
          this.pad2(dt.getDate()) +
          " " +
          this.pad2(dt.getHours()) +
          ":" +
          this.pad2(dt.getMinutes());
        return formatDateTime;
      }
    }),
    //min date
    (this.minDate = "1900-01-01 00:00:00.000"),
    (this.currentMonth = function() {
      var dt = new Date();
      var date =
        dt.getFullYear() + "-" + this.pad2(dt.getMonth() + 1) + "-" + "01";
      return date;
    }),
    (this.currentDateTime = function() {
      var dt = new Date();
      var date =
        dt.getFullYear() +
        "-" +
        this.pad2(dt.getMonth() + 1) +
        "-" +
        this.pad2(dt.getDate()) +
        " " +
        this.pad2(dt.getHours()) +
        ":" +
        this.pad2(dt.getMinutes()) +
        ":" +
        this.pad2(dt.getSeconds()) +
        "." +
        this.pad3(dt.getMilliseconds());
      return date;
    }),
    (this.currentDateTimewithoutsecond = function() {
      var dt = new Date();
      var date =
        dt.getFullYear() +
        "-" +
        this.pad2(dt.getMonth() + 1) +
        "-" +
        this.pad2(dt.getDate()) +
        " " +
        this.pad2(dt.getHours()) +
        ":" +
        this.pad2(dt.getMinutes());
      return date;
    }),
    (this.AddDays = function(d, days) {
      var dt = new Date(d.setDate(d.getDate() + days));
      var date =
        dt.getFullYear() +
        "-" +
        this.pad2(dt.getMonth() + 1) +
        "-" +
        this.pad2(dt.getDate()) +
        " " +
        this.pad2(dt.getHours()) +
        ":" +
        this.pad2(dt.getMinutes()) +
        ":" +
        this.pad2(dt.getSeconds()) +
        "." +
        this.pad3(dt.getMilliseconds());
      return date;
    }),
    (this.AddMonths = function(d, months) {
      var dt = new Date(d.setMonth(d.getMonth() + months));
      var date =
        dt.getFullYear() +
        "-" +
        this.pad2(dt.getMonth() + 1) +
        "-" +
        this.pad2(dt.getDate()) +
        " " +
        this.pad2(dt.getHours()) +
        ":" +
        this.pad2(dt.getMinutes()) +
        ":" +
        this.pad2(dt.getSeconds()) +
        "." +
        this.pad3(dt.getMilliseconds());
      return date;
    }),
    (this.todayDate = function() {
      var dt = new Date();
      var date =
        dt.getFullYear() +
        "-" +
        this.pad2(dt.getMonth() + 1) +
        "-" +
        this.pad2(dt.getDate());
      return date;
    }),
    //Pad a number to two digits
    (this.pad2 = function(number) {
      return (number < 10 ? "0" : "") + number;
    }),
    //Pad a number to three digits
    (this.pad3 = function(number) {
      return (number < 100 ? "0" : "") + number;
    }),
    (this.formatLocalDate = function(date) {
      var d = moment(date, "YYYY-MM-DD");
      var date =
        d.year() + "-" + this.pad2(d.month() + 1) + "-" + this.pad2(d.date());
      return date;
      //return d.year() + "-" + (d.month() + 1) + "-" + d.date();
    });
  (this.formatAddDay = function(date) {
    var d = moment(date, "YYYY-MM-DD");
    var date =
      d.year() +
      "-" +
      this.pad2(d.month() + 1) +
      "-" +
      this.pad2(d.date() + 1) +
      " " +
      this.pad2(d.hour()) +
      ":" +
      this.pad2(d.minute());
    return date;
  }),
    //Get Fiscal Period from Date
    (this.getFiscalPeriod = function(date) {
      var formatDate = moment(date, "YYYY-MM-DD");
      var currentYear = formatDate.year();
      var dateString = currentYear + "-04-" + "01";
      var currentYearAprilDate = moment(dateString);
      var fiscalDate = currentYearAprilDate;
      if (formatDate < currentYearAprilDate) {
        currentYear -= 1;
        dateString = currentYear + "-04-" + "01";
        fiscalDate = moment(dateString);
      }
      var monthDiff = Math.abs(formatDate.diff(fiscalDate, "Months"));
      var fiscalPeriod = currentYear + "" + this.pad2(monthDiff + 1);
      return fiscalPeriod;
    }),
    (this.setMaxHeight30PercentOfScreenHeight = function() {
      $(".height-30-percent").css("max-height", screen.height * 0.3 + "px");
      $(".height-30-percent").height(screen.height * 0.3 + "px");
    }),
    (this.setMaxHeight32PercentOfScreenHeight = function() {
      $(".height-32-percent").css("max-height", screen.height * 0.32 + "px");
      $(".height-32-percent").height(screen.height * 0.32 + "px");
    }),
    (this.setMaxHeight40PercentOfScreenHeight = function() {
      $(".height-40-percent").css("max-height", screen.height * 0.4 + "px");
      $(".height-40-percent").height(screen.height * 0.4 + "px");
    }),
    (this.setMaxHeight45PercentOfScreenHeight = function() {
      $(".height-45-percent").css("max-height", screen.height * 0.45 + "px");
      $(".height-45-percent").height(screen.height * 0.45 + "px");
    }),
    (this.setMaxHeight50PercentOfScreenHeight = function() {
      $(".height-50-percent").css("max-height", screen.height * 0.5 + "px");
      $(".height-50-percent").height(screen.height * 0.5 + "px");
    }),
    (this.setMaxHeight52PercentOfScreenHeight = function() {
      $(".height-52-percent").css("max-height", screen.height * 0.52 + "px");
      $(".height-52-percent").height(screen.height * 0.52 + "px");
    }),
    (this.setMaxHeight56PercentOfScreenHeight = function() {
      $(".height-56-percent").css("max-height", screen.height * 0.56 + "px");
      $(".height-56-percent").height(screen.height * 0.56 + "px");
    }),
    (this.setMaxHeight60PercentOfScreenHeight = function() {
      $(".height-60-percent").css("max-height", screen.height * 0.6 + "px");
      $(".height-60-percent").height(screen.height * 0.6 + "px");
    }),
    (this.formatMoney = function(n, c, d, t) {
      var c = isNaN((c = Math.abs(c))) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
          ? d +
            Math.abs(n - i)
              .toFixed(c)
              .slice(2)
          : "")
      );
    }),
    (this.initializeFilterToggle = function(classname) {
      var self = this;
      $("#btnClick").click(function() {
        $(".oo_hideshowclassdetail").toggle();
      });
      $("#btnClick").on("click", function() {
        if ($(".showclass").css("display") != "none") {
          $(".hideclass").show();
          $(".showclass").hide();
          $("#btnClick").css("top", "0px");
          $("tbody")
            .removeClass(classname)
            .addClass("height-56-percent");
          // .addClass("height-60-percent");
          self.setMaxHeight56PercentOfScreenHeight();
        } else if ($(".hideclass").css("display") != "none") {
          $(".showclass").show();
          $(".hideclass").hide();
          $("#btnClick").css("top", "-2px");
          $("tbody")
            .removeClass("height-56-percent") // 60
            .addClass(classname);
          if (classname === "height-30-percent") {
            self.setMaxHeight30PercentOfScreenHeight();
          } else if (classname === "height-32-percent") {
            self.setMaxHeight32PercentOfScreenHeight();
          } else if (classname === "height-40-percent") {
            self.setMaxHeight40PercentOfScreenHeight();
          } else if (classname === "height-45-percent") {
            self.setMaxHeight45PercentOfScreenHeight();
          } else if (classname === "height-50-percent") {
            self.setMaxHeight50PercentOfScreenHeight();
          } else if (classname === "height-52-percent") {
            self.setMaxHeight52PercentOfScreenHeight();
          } else if (classname === "height-60-percent") {
            self.setMaxHeight60PercentOfScreenHeight();
          }
        }
      });
    }),
    (this.bindCurrency = function(val) {
      var curr = parseFloat(val);
      var result = curr
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      return result;
    });
  // (this.userRights =function(menuid){
  //   var self=this;
  //     self.$store.dispatch("loginStore/getscrsec", { menuID: menuid }).then(response => {
  //       if(response.data.IsSuccess)
  //       {
  //           var uAlwWrite=response.data.Data.Write
  //           //self.uAlwWrite=false
  //           var uAlwRead=response.data.Data.Read
  //           var uAlwPrt=response.data.Data.Print
  //           var uAlwImp=response.data.Data.Import
  //       }
  //       common.stopLoading();
  //     }, error => {
  //       common.stopLoading();
  //   });
  // });
  this.setLeftMenuToggle = function() {
    setTimeout(() => {
      $(".sidebar-dropdown > a").on("click", function() {
        $(".sidebar-submenu").slideUp(200);
        if (
          $(this)
            .parent()
            .hasClass("active")
        ) {
          $(".sidebar-dropdown").removeClass("active");
          $(this)
            .parent()
            .removeClass("active");
        } else {
          // if($(this).next(".sidebar-submenu").has( "ul" ).has( "li" ).length > 0){
          //    $(this).next(".sidebar-submenu").has( "ul" ).has( "li" ).addClass("active");
          // }else
          {
            $(".sidebar-dropdown").removeClass("active");
            $(this)
              .next(".sidebar-submenu")
              .slideDown(200);
            $(this)
              .parent()
              .addClass("active");
          }
        }
      });

      $("#close-sidebar").on("click", function() {
        $(".page-wrapper").removeClass("toggled");
      });
      $("#show-sidebar").on("click", function() {
        $(".page-wrapper").addClass("toggled");
      });
    }, 100);
  };
  this.exportToExcel = function(list, filename) {
    var worksheet = "";
    let workbook = XLSX.utils.book_new();
    for (var i = 0; i < list.length; i++) {
      worksheet = XLSX.utils.json_to_sheet(list[i], {
        cellDates: false, // 将日期类型的单元格导出为字符串
        cellStyles: true, // 将单元格样式导出
        raw: true // 以原始格式导出数据
      });
      XLSX.utils.book_append_sheet(workbook, worksheet);
    }
    XLSX.writeFile(
      workbook,
      filename + this.currentDateTimewithoutsecond() + ".xlsx"
    );
  };

  this.formatCurrency = function(str) {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "HKD"
    });
    return formatter.format(str).replace("HK", "");
  };

  this.formatNumberWithComma = function(value, fixNum = 2) {
    return String(Number(value).toFixed(fixNum)).replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ","
    );
  };
}
